import { Box, Button, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import PrintBtn from "src/components/shared/PrintBtn";
import ViewBtn from "src/components/shared/ViewBtn";
import { BatchStatus, COMMOM_STATUS, orderStatusFormatted, WAREHOUSE_MANAGEMENT_STATUS, WAREHOUSE_TRANSFER_IN_TRANSLATE, WAREHOUSE_TRANSFER_IN_TYPE } from "src/constant";
import useAppGlobal from "src/context/useAppGlobal";
import convertCurrency, { convertIntMoney } from "src/helper/convertCurrency";
import useWarehouseTransferList from "src/hooks/warehouse-transfer/useWarehouseTransferList";
import { v4 as uuid } from "uuid";
import ImportProdDialog from "../ImportProdDialog";
import ImportReviewDialog from "../ImportReviewDialog";
import useQueryParams from "src/hooks/useQueryParams";
import ProcessingBadge from "src/components/shared/ProcessingBagde";
import DeleteBtn from "src/components/shared/DeleteBtn";
import UpdateBtn from "src/components/shared/UpdateBtn";
import useWTRemove from "src/hooks/warehouse-transfer/useWTRemove";
import ConfirmComp from "src/components/shared/ConfirmComp";
import { enqueueSnackbar } from "notistack";
import useWarehouseTransferExport from "src/hooks/warehouse-transfer/useWarehouseTranferExport";
import useProcessLogDetail from "src/hooks/process-log/useProcessLogDetail";
import appConfig from "src/config/env";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/vi";
import ImportFormDialog from "../ImportFormDialog";
import useAuthGlobal from "src/context/useAuthGlobal";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

dayjs.extend(relativeTime);
dayjs.locale("vi");

export default function useInventoryInBody({ keyword, searchBy, paramsQuery, date, warehouseId }) {
  const permissionCheck = useRoleCheck();
  const { userMe } = useAuthGlobal();
  const { handleOpenDialog } = useAppGlobal();
  const [option] = useQueryParams();
  const [pagi, setPagi] = useState({
    limit: 50,
    skip: 0,
  });
  const [logId, setLogId] = useState();
  const rawQuery = { ...(paramsQuery || {}) };
  const { incomingFromSource, ...query } = rawQuery;

  const fromSource =
    query.provider && !query.fromWarehouse
      ? "Provider"
      : query.fromWarehouse && !query.provider
        ? "Warehouse"
        : incomingFromSource === "Provider" || incomingFromSource === "Warehouse"
          ? incomingFromSource
          : undefined;

  const listParams = {
    ...pagi,
    sortOrder: "desc",
    toWarehouse: warehouseId ?? userMe?.currentWarehouse?._id,
    statusOut: orderStatusFormatted.Exported,
    statusIn: WAREHOUSE_MANAGEMENT_STATUS[option?.tab],
    searchField: "innInCode",
    searchValue: !!keyword ? keyword : undefined,
    // type: RETURN_REFUND_OPTIONS.NEW,
    ...query,
    ...date,
    ...(fromSource ? { fromSource } : {}),
  };

  const { data: inventoryIn, isLoading, error, mutate: wtMutate } = useWarehouseTransferList(listParams);

  const { trigger: printWT } = useWarehouseTransferExport();
  const { trigger: removeWT } = useWTRemove();
  const { closeDialog } = useAppGlobal();

  const handleReview = (val, type) => {
    handleOpenDialog({
      title: `Xem  ${val?.statusIn === orderStatusFormatted.Pending ? "thông tin" : "phiếu"} nhập kho`,
      content: (
        <ImportReviewDialog
          val={val}
          transferFileType={type}
        />
      ),
      size: "xl",
    });
  };

  const header = [
    {
      id: uuid(),
      title: "STT",
      align: "center",
    },
    {
      id: uuid(),
      title: "Mã PNK",
      align: "center",
    },
    {
      id: uuid(),
      title: "Kho xuất/ NCC",
      align: "center",
    },
    ...(permissionCheck([PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN])
      ? [
          {
            id: uuid(),
            title: "Kho nhập",
            align: "center",
          },
        ]
      : []),
    {
      id: uuid(),
      title: "Hình thức",
      align: "center",
    },
    {
      id: uuid(),
      title: "Trạng thái",
      align: "center",
    },

    {
      id: uuid(),
      title: "Tổng sl nhập",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thành tiền",
      align: "center",
    },
    {
      id: uuid(),
      title: "Hình thức thanh toán",
      align: "center",
    },
    {
      id: uuid(),
      title: "Xác nhận",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thao tác",
      align: "center",
    },
  ];

  const handleConfirm = (item) => {
    handleOpenDialog({
      size: "xl",
      content: <ImportProdDialog item={item} />,
    });
  };

  const handleRemoveWT = async (id) => {
    const res = await removeWT({
      pathIncluded: {
        id: id,
      },
    });
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  const handleDelete = (item) => {
    handleOpenDialog({
      content: (
        <ConfirmComp
          name={item?.name}
          onConfirm={() => handleRemoveWT(item?._id)}
        />
      ),
      size: "md",
    });
  };

  const handleEdit = (item) => {
    handleOpenDialog({
      content: (
        <ImportFormDialog
          item={item}
          title="Chỉnh sửa lệnh nhập kho"
          mode="update"
          mutateList={wtMutate}
        />
      ),
      size: "xl",
    });
  };

  const { mutate } = useProcessLogDetail(logId);

  const handlePrint = async (item) => {
    const res = await printWT({
      body: {
        warehouseTransferIds: [item?._id],
        transferFileType: orderStatusFormatted.Imported,
      },
    });
    if (res?.success) {
      setLogId(res?.data?._id);
      handleGetLog(res?.data?._id);
      return enqueueSnackbar("Tiến hành xuất phiếu...", { variant: "success", className: "notistack-confirm" });
    } else {
      return enqueueSnackbar(res?.error?.message ?? res?.error?.message, {
        variant: "error",
      });
    }
  };

  const handleGetLog = (logIdParam) => {
    const logIdToUse = logIdParam || logId;
    if (!logIdToUse) return;

    const timeOut = setInterval(async () => {
      try {
        const res = await mutate();
        if (res?.success) {
          if (res.data.status === COMMOM_STATUS.done) {
            closeDialog();
            if (Array.isArray(res.data?.urls)) {
              res.data.urls.forEach((v) => {
                window.open(`${appConfig.API_FILE}/${v}`, "_blank");
              });
            }
            clearInterval(timeOut);
          }

          if (res.data.status === COMMOM_STATUS.error) {
            enqueueSnackbar("Không xuất được phiếu", { variant: "error" });
            clearInterval(timeOut);
          }
        } else {
          enqueueSnackbar("Không xuất được phiếu", { variant: "error" });
          clearInterval(timeOut);
        }
      } catch (err) {
        clearInterval(timeOut);
      }
    }, 1000);
  };

  const bodyList = Array.isArray(inventoryIn?.data)
    ? inventoryIn.data.map((v, index) => {
        const hasProvider = Boolean(v?.provider?._id ?? v?.provider);
        const hasFromWarehouse = Boolean(v?.fromWarehouse?._id ?? v?.fromWarehouse);
        const isSlipFromInternalWarehouse = hasFromWarehouse && !hasProvider;
        const isSlipFromNcc = hasProvider;
        // Phiếu từ NCC (provider có id): chỉ sửa khi statusIn === Pending (Chờ nhập kho / chờ nhập hàng).
        const nccEditAllowed = isSlipFromNcc && v?.statusIn !== BatchStatus.Pending;
        const editBlockedBySourceRule = isSlipFromInternalWarehouse || nccEditAllowed;
        // console.log({ hasFromWarehouse });

        const totalImported = v?.totalImported ?? 0;
        const totalExported = v?.totalExported ?? 0;
        const isLocked = Boolean(v?.innInCode);

        const canUpdate = (hasProvider && totalImported !== v?.qty) || (totalExported !== 0 && totalImported === totalExported);

        const isDeleteDisabled = (!hasProvider && totalImported !== 0) || isLocked;

        return {
          ...v,
          no: index + 1,
          fromWHouse: (
            <Box>
              <Typography
                fontWeight="bold"
                sx={{ fontSize: "12px", whiteSpace: "nowrap" }}
              >
                {hasProvider ? v?.provider?.name : v?.fromWarehouse?.name}
              </Typography>
              <Typography fontSize="12px">{v?.exportedAt ? dayjs(v.exportedAt).format("DD-MM-YYYY") : "-"}</Typography>
              <Typography sx={{ fontSize: "10px" }}>{v?.exportedAt ? `(${dayjs(v.exportedAt).fromNow()})` : ""}</Typography>
            </Box>
          ),
          ...(permissionCheck([PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN])
            ? {
                toWHouse: (
                  <Box>
                    <Typography
                      fontWeight="bold"
                      sx={{ fontSize: "12px", whiteSpace: "nowrap" }}
                    >
                      {v?.toWarehouse?.name}
                    </Typography>
                    <Typography fontSize="12px">{v?.exportedAt ? dayjs(v.exportedAt).format("DD-MM-YYYY") : "-"}</Typography>
                    <Typography sx={{ fontSize: "10px" }}>{v?.exportedAt ? `(${dayjs(v.exportedAt).fromNow()})` : ""}</Typography>
                  </Box>
                ),
              }
            : {}),
          innInCode: v?.innInCode ?? "-",
          status: (
            <ProcessingBadge
              value={WAREHOUSE_TRANSFER_IN_TRANSLATE[v?.statusIn]}
              asset={{ color: v?.statusIn, text: v?.statusIn }}
            />
          ),
          type: (
            <ProcessingBadge
              value={WAREHOUSE_TRANSFER_IN_TYPE[v?.type]}
              asset={{ color: v?.type, text: v?.type }}
            />
          ),
          totalQty: (
            <Box
              textAlign="center"
              sx={{ maxWidth: "180px" }}
            >
              <Typography fontWeight="bold">{convertIntMoney(v?.subTotal)} đồng</Typography>
              <Typography
                fontSize="10px"
                sx={{
                  fontStyle: "italic",
                  color: "var(--main-grey)",
                  whiteSpace: "normal",
                }}
              >
                {convertCurrency(v?.subTotal)} đồng
              </Typography>
            </Box>
          ),
          total: `${totalImported}/${totalExported}`,
          approve: (
            <Button
              disabled={
                v?.statusIn === orderStatusFormatted.Imported ||
                !permissionCheck([PERMISSIONS.PREPARE_WAREHOUSETRANSFERIMPORT_ALL, PERMISSIONS.PREPARE_WAREHOUSETRANSFERIMPORT_OWN])
              }
              onClick={() => handleConfirm(v)}
              size="small"
              variant="contained"
              sx={{ fontSize: "12px", whiteSpace: "nowrap" }}
            >
              Nhập hàng
            </Button>
          ),
          payment: <Typography sx={{ fontSize: "12px" }}>{v?.paymentMethod?.name}</Typography>,
          action: (
            <Box
              display="flex"
              gap="6px"
              width="200px"
              justifyContent="center"
            >
              <ViewBtn
                disabled={!permissionCheck([PERMISSIONS.VIEW_WAREHOUSETRANSFERIMPORT_ALL, PERMISSIONS.VIEW_WAREHOUSETRANSFERIMPORT_OWN])}
                handleView={() => handleReview(v, orderStatusFormatted.Imported)}
              />

              <PrintBtn handlePrint={() => handlePrint(v)} />

              <UpdateBtn
                disabled={
                  isLocked ||
                  canUpdate ||
                  editBlockedBySourceRule ||
                  !permissionCheck([PERMISSIONS.UPDATE_WAREHOUSETRANSFERIMPORT_ALL, PERMISSIONS.UPDATE_WAREHOUSETRANSFERIMPORT_OWN])
                }
                handleUpdate={() => handleEdit(v)}
              />

              <DeleteBtn
                disabled={isDeleteDisabled || !permissionCheck([PERMISSIONS.DELETE_WAREHOUSETRANSFERIMPORT_ALL, PERMISSIONS.DELETE_WAREHOUSETRANSFERIMPORT_OWN])}
                handleDelete={() => handleDelete(v)}
              />
            </Box>
          ),
        };
      })
    : null;

  const sortData = ["no", "innInCode", "fromWHouse", "toWHouse", "type", "status", "total", "totalQty", "payment", "approve", "action"];

  return {
    header,
    sortData,
    bodyList,
    isLoading,
    error,
    total: inventoryIn?.count,
    pagi,
    setPagi,
    wtMutate,
  };
}
